import { useCallback } from "react";
import { toast } from "react-toastify";

export function useToast() {
  const success = useCallback((msg: string, delay?: number) => {
    toast.success(msg, { autoClose: 5000, delay: delay });
  }, []);

  const error = useCallback((msg: string, delay?) => {
    toast.error(msg, { autoClose: false, delay: delay });
  }, []);

  const clear = useCallback(() => {
    toast.dismiss();
  }, []);

  return { success, error, clear };
}
